import { render, staticRenderFns } from "./AssigmentItem.vue?vue&type=template&id=77b6d206&scoped=true"
import script from "./AssigmentItem.vue?vue&type=script&lang=js"
export * from "./AssigmentItem.vue?vue&type=script&lang=js"
import style0 from "./AssigmentItem.vue?vue&type=style&index=0&id=77b6d206&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b6d206",
  null
  
)

export default component.exports